import { EINSTUFUNG, farbzustand, kriterium } from './gemeinsam';
import { DataTable, EmptyState, StatusBadge, type Spalte } from '../../muster';

/**
 * Die Einstufungsregeln — der Rang entscheidet, die erste passende Regel
 * gewinnt.
 */
export function Einstufungsregeln({ regeln }: { regeln: any[] }) {
  const spalten: Spalte<any>[] = [
    { schluessel: 'rang', titel: 'Rang', art: 'zahl', breite: '80px', wert: (r) => r.rang },
    {
      schluessel: 'regel', titel: 'Regel', immerSichtbar: true,
      wert: (r) => r.bezeichnung,
      inhalt: (r) => (
        <>
          {r.bezeichnung}
          <div className="schwach" style={{ fontSize: 11 }}>{r.begruendung}</div>
        </>
      ),
    },
    {
      /*
        Was die Regel überhaupt greift. Ohne diese Spalte ist die Tabelle
        nicht prüfbar: 'Rohr in Trockenbauwand' sagt nicht, WORAN Trockenbau
        erkannt wird — und genau daran hängt, ob die Regel die Betonwand
        mitnimmt.
      */
      schluessel: 'trifft', titel: 'Trifft auf', sortierbar: false,
      wert: (r) => [
        kriterium('A', r.gewerkA, r.bauteilartA, r.kategorieA, r.typMusterA),
        kriterium('B', r.gewerkB, r.bauteilartB, r.kategorieB, r.typMusterB),
      ].filter(Boolean).join(' · '),
      inhalt: (r) => {
        const zeilen = [
          kriterium('A', r.gewerkA, r.bauteilartA, r.kategorieA, r.typMusterA),
          kriterium('B', r.gewerkB, r.bauteilartB, r.kategorieB, r.typMusterB),
        ].filter(Boolean);

        if (zeilen.length === 0) {
          return <span className="schwach">nur über die Toleranz</span>;
        }

        return (
          <span style={{ fontSize: 11 }}>
            {zeilen.map((zeile, i) => <div key={i}>{zeile}</div>)}
          </span>
        );
      },
    },
    {
      schluessel: 'einstufung', titel: 'Einstufung', art: 'status', breite: '170px',
      wert: (r) => EINSTUFUNG[r.einstufung]?.text ?? r.einstufung,
      inhalt: (r) => (
        <StatusBadge
          klein
          zustand={farbzustand(EINSTUFUNG[r.einstufung]?.farbe)}
          text={EINSTUFUNG[r.einstufung]?.text ?? r.einstufung}
        />
      ),
    },
    {
      schluessel: 'toleranz', titel: 'Toleranz', art: 'zahl', einheit: 'mm',
      nachkomma: 0, breite: '120px',
      wert: (r) => r.toleranzMm,
    },
    {
      schluessel: 'herkunft', titel: 'Herkunft', art: 'status', breite: '150px',
      wert: (r) => (r.geprueft ? 'geprüft' : r.herkunft),
      inhalt: (r) => (r.geprueft
        ? <StatusBadge zustand="gut" text="geprüft" klein />
        : <span className="schwach" style={{ fontSize: 11 }}>{r.herkunft}</span>),
    },
  ];

  return (
    <DataTable
      name="Einstufungsregeln"
      beschreibung={'Der Rang entscheidet: die erste passende Regel gewinnt. Die '
        + 'Reihenfolge liest sich als Frage — ist es ein Bauteil (5–9), ist es '
        + 'überhaupt eine Kollision (11–19), und erst dann: was für eine (ab 20). '
        + 'Eine Ausschlussregel hinter der Durchdringungsregel wäre wirkungslos, und '
        + 'zwar unauffällig: Die Fälle stünden weiter als „prüfen" in der Liste.'}
      spalten={spalten}
      zeilen={regeln ?? []}
      schluessel={(r) => r.bezeichnung}
      sortierung={{ spalte: 'rang', richtung: 'auf' }}
      ausfuhr
      leer={(
        <EmptyState
          titel="Keine Einstufungsregel gepflegt."
          erklaerung={'Ohne Regeln bleibt jede gefundene Berührung „prüfen" — die '
            + 'Vorsortierung, wegen der es dieses Modul gibt, fällt aus.'}
        />
      )}
    />
  );
}
